"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.currentSortBy = exports.updateSortBy = exports.changePageIndex = exports.changeItemsPerPage = exports.updatePagination = void 0;
var updatePagination = function (pagination) { return ({
    currentPageIndex: pagination.CurrentPageIndex ? pagination.CurrentPageIndex : 0,
    currentPageFirstItemIndex: pagination.CurrentPageFirstItemIndex ? pagination.CurrentPageFirstItemIndex : 0,
    currentItemsOnPage: pagination.CurrentItemsOnPage,
    resultsTotal: pagination.ResultsTotal,
    currentItemsPerPage: pagination.CurrentItemsPerPage,
    sortOptions: pagination.SortOptions
        ? pagination.SortOptions.map(function (sort) { return ({
            name: sort.Name,
            displayName: sort.DisplayName,
            selected: sort.Selected
        }); }) : null
}); };
exports.updatePagination = updatePagination;
var changeItemsPerPage = function (pagination, itemsPerPage) {
    var firstArticleNumberOnNewPage = pagination.currentPageIndex * itemsPerPage + 1;
    var requestedPageIndex = firstArticleNumberOnNewPage > pagination.resultsTotal
        ? Math.floor(pagination.resultsTotal / itemsPerPage)
        : pagination.currentPageIndex;
    return __assign(__assign({}, pagination), { currentPageIndex: requestedPageIndex, currentItemsPerPage: itemsPerPage });
};
exports.changeItemsPerPage = changeItemsPerPage;
var changePageIndex = function (pagination, requestedPageIndex) {
    return __assign(__assign({}, pagination), { currentPageIndex: requestedPageIndex });
};
exports.changePageIndex = changePageIndex;
var updateSortBy = function (pagination, requestSort) {
    if (pagination.sortOptions) {
        return __assign(__assign({}, pagination), { sortOptions: pagination.sortOptions.map(function (option) { return (__assign(__assign({}, option), { selected: requestSort === option.name })); }) });
    }
    return pagination;
};
exports.updateSortBy = updateSortBy;
var currentSortBy = function (sortOptions) {
    if (sortOptions && sortOptions.length) {
        var selected = sortOptions.filter(function (option) { return option.selected; });
        if (selected.length > 0) {
            return selected[0];
        }
        return sortOptions[0];
    }
};
exports.currentSortBy = currentSortBy;
